/* eslint-disable */
/* tslint:disable */
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

export interface MultilingualKeyDto {
  fi: string;
  en: string;
  sv: string;
}

export interface ExtranetCustomerUserProfessionalRoleDto {
  id: number;
  role: string;
  isActive: boolean;
  displayName: MultilingualKeyDto;
}

export enum ExtranetCustomerUserRoleEnum {
  CustomerUser = "customer-user",
  CustomerViewOrders = "customer-view-orders",
  CustomerUserManagement = "customer-user-management",
  CustomerBuyer = "customer-buyer",
  InvoiceViewing = "invoice-viewing",
  CompanyInformationManagement = "company-information-management",
  ContractInformationViewing = "contract-information-viewing",
}

export interface ExtranetCustomerUserRoleDto {
  id: number;
  role: ExtranetCustomerUserRoleEnum;
  color: string;
  displayName: MultilingualKeyDto;
}

export interface ExtranetUserDto {
  id: number;
  keycloakId: string;
  firstName: string;
  lastName: string;
  streetName: string;
  postCode: string;
  townName: string;
  countryCode: string;
  countryName: string;
  emailAddress: string;
  phoneNumber: string;
  userName: string;
  certificateCardNumber: string;
  professionalRoles: ExtranetCustomerUserProfessionalRoleDto[];
  professionalRolesSelected: boolean;
  marketingAuthorizationDate: string | null;
  cookiePolicyApprovalDate: string | null;
  extranetTermsOfUseApprovalDate: string | null;
  privacyPolicyApprovalDate: string | null;
  roles: ExtranetCustomerUserRoleDto[];
}

export interface UpdateUserInformationBodyDto {
  firstName?: string;
  lastName?: string;
  streetName?: string;
  postCode?: string;
  townName?: string;
  countryCode?: string;
  emailAddress?: string;
  phoneNumber?: string;
  certificateCardNumber?: string;
  professionalRolesSelected?: boolean;
  professionalRoleIds?: number[];
}

export type MultilingualString = object;

export interface ExtranetCompanyRoleDto {
  id: number;
  role: string;
  displayName: MultilingualString;
  isActive: boolean;
}

export interface ExtranetCustomerListItemDto {
  id: number;
  kelaNumber: string;
  mainPharmacyKelaNumber: string;
  officialName: string;
  type: "pharmacy" | "company";
  hasDoseDelivery: boolean;
  name: string;
  companyRole: ExtranetCompanyRoleDto | null;
  buyingBan: boolean;
}

export interface UpdateUserApprovalBodyDto {
  approval: boolean;
}

export enum DoseDispensingProductSortKey {
  Vnr = "vnr",
  Name = "name",
  Substance = "substance",
}

export enum DoseDispensingProductHalving {
  Yes = "yes",
  No = "no",
  Always = "always",
}

export enum DoseDispensingProductAvailability {
  Available = "available",
  InShortSupply = "in-short-supply",
  OutOfStock = "out-of-stock",
  ToBeDiscontinued = "to-be-discontinued",
  Discontinued = "discontinued",
}

export enum DoseDispensingProductType {
  Drug = "drug",
  Supplement = "supplement",
  Unknown = "unknown",
}

export interface GetDoseDispensingProductsQueryDto {
  cid: number;
  pageSize?: number;
  page?: number;
  sortKey?: DoseDispensingProductSortKey;
  sortOrder?: "asc" | "desc";
  manufacturerName?: string;
  halving?: DoseDispensingProductHalving[];
  search?: string;
  availableForCustomers?: DoseDispensingProductAvailability[];
  type?: DoseDispensingProductType[];
}

export interface ListDto {
  pageSize: number;
  page: number;
  hasMore: boolean;
  total: number;
}

export interface DoseDispensingProductsListItemDto {
  id: number;
  activeSubstances: string;
  halving: "Yes" | "No" | "Always";
  availability: "Available" | "In short supply" | "To be discontinued" | "Discontinued" | "Out of stock";
  manufacturerName: string;
  name: string;
  productNumber: string;
  publishDate: string;
  strength: string;
  format: string;
  substituteProduct: DoseDispensingProductsListItemDto;
  seamType: string;
  narcoticType: string;
  centralNervousSystemDrugType: string;
  trafficHazardType: string;
}

export interface ExtranetDrugGuideGroupTradenameDto {
  id: string;
  name: string;
  included: boolean;
}

export interface ExtranetDrugGuideGroupDto {
  id: number;
  title: string;
  tradenames: ExtranetDrugGuideGroupTradenameDto[];
}

export interface ExtranetDrugGuidePackageDto {
  id: string;
  type: string;
  class: string;
}

export interface ExtranetDrugGuideTherapyClassificationDto {
  class: string;
  description: string;
}

export interface ExtranetDrugGuideMarketingCompanyDto {
  id: number;
  name: string;
  wholesaler: string;
  addressName: string;
  postalAddress: string;
  postalCode: string;
  city: string;
  country: string;
  email: string;
  www: string;
  phone: string;
}

export interface ExtranetDrugGuideSectionDto {
  id: string;
  name: string;
  version: string;
  level: number;
  order: number;
  title: string;
  content: string;
}

export interface ExtranetDrugGuideDocumentDto {
  id: string;
  language: string;
  title: string;
  modifiedDate: string;
  groups: ExtranetDrugGuideGroupDto[];
  package: ExtranetDrugGuidePackageDto;
  therapyClassifications: ExtranetDrugGuideTherapyClassificationDto[];
  marketingCompany: ExtranetDrugGuideMarketingCompanyDto;
  sections: ExtranetDrugGuideSectionDto[];
}

export interface ExtranetPharmacaFullAdditionalDosageInformationDto {
  code: string;
  displayName: string;
}

export interface ExtranetPharmacaFullDrugFeatureDto {
  code: string;
  codeSystem: string;
  name: string;
}

export interface ExtranetPharmacaFullMarkingDto {
  code: string;
  name: string;
  format: string;
}

export interface ExtranetPharmacaFullImageDto {
  id: string;
  drugWidth: string | null;
  drugLength: string | null;
  drugSizeUnit: string | null;
  colours: ExtranetPharmacaFullDrugFeatureDto[];
  markings: ExtranetPharmacaFullMarkingDto[] | null;
  shapes: ExtranetPharmacaFullDrugFeatureDto[];
  dividingLines: ExtranetPharmacaFullDrugFeatureDto[];
  additionalInformation: string | null;
  urls: string[];
}

export interface ExtranetPharmacaFullDrugDto {
  id: string;
  tradename: string;
  lactose: string;
  crushable: string;
  additionalDosageInformation: ExtranetPharmacaFullAdditionalDosageInformationDto[] | null;
  images: ExtranetPharmacaFullImageDto[] | null;
}

export interface ExtranetFimea75MedicinalSubstanceDto {
  id: number;
  substanceId: string;
  name: string;
  atcCode: string;
  atcDescription: string;
  class: string;
  commentFi: string;
  commentSv: string;
  commentEn: string;
}

export interface ExtranetFimea75DataDto {
  versionRunDate: string;
  versionMaterialBatch: string;
  versionMonthBatch: string;
  versionCoverage: number;
  packageId: string;
  medicinalSubstances: ExtranetFimea75MedicinalSubstanceDto[];
}

export interface ExtranetDrugShortageDto {
  vnr: string;
  isValid: string;
  startDate: string;
  endDate: string;
  announcementDate: string;
  updateDate: string;
  company: string;
  wholeMaterialUpdateDate: string;
}

export interface ExtranetDoseDispensingProductMetadataDto {
  drugGuideDocument: ExtranetDrugGuideDocumentDto;
  pharmacaFullData: ExtranetPharmacaFullDrugDto;
  fimea75Data: ExtranetFimea75DataDto;
  drugShortage: ExtranetDrugShortageDto;
}

export interface ExtranetPhotobankImageDto {
  id: number;
  url: string;
  format: string;
  typeId: number;
}

export interface ExtranetPhotobankProductDto {
  productId: number;
  productNumber: string;
  width: number;
  height: number;
  length: number | null;
  images: ExtranetPhotobankImageDto[];
}

export enum ExtranetMaterialProductEnum {
  Video = "video",
  Document = "document",
}

export enum ExtranetMaterialLanguageOption {
  Fi = "fi",
  Sv = "sv",
  En = "en",
}

export interface GetExtranetMaterialProductsQueryDto {
  search?: string;
  pageSize?: number;
  customerId: number;
  page?: number;
  /** @format date */
  beforeDate?: string;
  /** @format date */
  afterDate?: string;
  tagIds?: number[];
  type?: ExtranetMaterialProductEnum;
  ids?: string[];
  language?: ExtranetMaterialLanguageOption;
}

export interface ExtranetDocumentDto {
  id: number;
  filename: string;
  fileType: string;
  documentUrl: string;
}

export interface ExtranetTagDto {
  id: number;
  name: MultilingualKeyDto;
}

export interface ExtranetPublishPlatformDto {
  id: number;
  name: string;
  isActive: boolean;
}

export interface ExtranetManufacturerDto {
  id: number;
  name: string;
  isActive: boolean;
}

export interface ExtranetProductImageDto {
  id: number;
  mediabankId: number;
  desktopUrl: string;
  desktopLargeUrl: string;
  desktopWideUrl: string;
  mobileUrl: string;
  orderIndex: number;
}

export interface ExtranetProductDto {
  id: number;
  productNumber: string;
  name: MultilingualKeyDto;
  productDescription: MultilingualKeyDto;
  productFamily: string;
  isActive: boolean;
  manufacturer: ExtranetManufacturerDto;
  images: ExtranetProductImageDto[];
}

export interface ExtranetDocumentProductDto {
  id: number;
  /** @format date */
  updatedAt: string;
  documentFi: ExtranetDocumentDto | null;
  documentSv: ExtranetDocumentDto | null;
  documentEn: ExtranetDocumentDto | null;
  tags: ExtranetTagDto[] | null;
  publishPlatforms: ExtranetPublishPlatformDto[] | null;
  product: ExtranetProductDto;
}

export interface ExtranetVideoDto {
  id: number;
  vimeoUri: string;
  videoUrl: string;
  filename: string;
}

export interface ExtranetAccessPeriodDto {
  id: number;
  isUnlimited: boolean;
  duration: number;
  durationUnit: "day" | "month" | "year";
  isActive: boolean;
}

export interface ExtranetLanguageDto {
  id: number;
  code: string;
  name: MultilingualKeyDto;
}

export interface ExtranetDeliveryMethodDto {
  id: number;
  name: MultilingualKeyDto;
}

export interface ExtranetChapterDto {
  uri: string;
  timecode: string;
  title: string;
}

export interface ExtranetVideoProductDto {
  id: number;
  durationFi: number | null;
  durationSv: number | null;
  durationEn: number | null;
  /** @format date */
  updatedAt: string;
  videoFi: ExtranetVideoDto | null;
  videoSv: ExtranetVideoDto | null;
  videoEn: ExtranetVideoDto | null;
  teaserFi: ExtranetVideoDto | null;
  teaserSv: ExtranetVideoDto | null;
  teaserEn: ExtranetVideoDto | null;
  accessPeriod: ExtranetAccessPeriodDto | null;
  tags: ExtranetTagDto[] | null;
  publishPlatforms: ExtranetPublishPlatformDto[] | null;
  languages: ExtranetLanguageDto[] | null;
  deliveryMethods: ExtranetDeliveryMethodDto[] | null;
  chaptersFi?: ExtranetChapterDto[];
  chaptersSv?: ExtranetChapterDto[];
  chaptersEn?: ExtranetChapterDto[];
  product: ExtranetProductDto;
}

export interface ExtranetMaterialProductListItemDto {
  id: number;
  productNumber: string;
  documentProduct?: ExtranetDocumentProductDto;
  videoProduct?: ExtranetVideoProductDto;
}

export interface GetExtranetMaterialProductTagQueryDto {
  lang?: string;
}

export enum ExtranetCustomerType {
  Pharmacy = "pharmacy",
  Company = "company",
}

export enum ExtranetCustomerInvoiceSendingMethod {
  Einvoice = "einvoice",
  Email = "email",
  Print = "print",
}

export interface ExtranetCustomerExternalDeliveryInfoDto {
  fifthAddressNumber: string;
  businessId: string;
  officialName: string;
  marketingName: string;
  kelaNumber: string;
  streetAddress: string;
  zipCode: string;
  municipality: string;
  routeCode: string;
}

export interface ExtranetCustomerAddressCardDto {
  id: number;
  customershipId: number;
  streetName: string;
  townName: string;
  postCode: string;
  countryCode: string;
  countryName: string;
  phoneNumber: string;
  emailAddress: string;
  contactPersonName: string;
  webAddress: string;
  longitude: number;
  latitude: number;
  isActive: boolean;
}

export interface ExtranetCustomerDetailsDto {
  id: number;
  kelaNumber: string;
  mainPharmacyKelaNumber: string;
  businessId: string;
  customershipId: number;
  officialName: string;
  representativePersonName: string;
  department: string;
  type: ExtranetCustomerType;
  taxCode: string;
  languageCode: string;
  name: string;
  isMainPharmacy: boolean;
  deliveryRouteId: number;
  deliveryRouteName: string;
  wellbeingServicesCountyId: number;
  hasDoseDelivery: boolean;
  doseDeliveryContactPersonName: string;
  doseDeliveryEmailAddress: string;
  doseDeliveryPhoneNumber: string;
  invoiceSendingMethod: ExtranetCustomerInvoiceSendingMethod;
  invoiceRecipientOrganisationUnitNumber: string;
  invoiceToIntermediator: string;
  externalDeliveryInfo: ExtranetCustomerExternalDeliveryInfoDto;
  buyerAddressCard: ExtranetCustomerAddressCardDto;
  billingAddressCard: ExtranetCustomerAddressCardDto;
  deliveryAddressCard: ExtranetCustomerAddressCardDto;
  companyRole: ExtranetCompanyRoleDto;
  buyingBan: boolean;
}

export interface ExtranetCustomerUserRolesDto {
  isAdmin: boolean;
  roles: ExtranetCustomerUserRoleDto[];
}

export interface PostInviteUserBodyDto {
  userEmail: string;
  roles: (
    | "customer-user"
    | "customer-view-orders"
    | "customer-user-management"
    | "customer-buyer"
    | "invoice-viewing"
    | "company-information-management"
    | "contract-information-viewing"
  )[];
}

export interface ExtranetInviteUserDto {
  inviteCodeId: number;
  inviteCode: string;
  userEmail: string;
  emailSent: boolean;
  /** @format date */
  validUntil: string;
  roles: (
    | "customer-user"
    | "customer-view-orders"
    | "customer-user-management"
    | "customer-buyer"
    | "invoice-viewing"
    | "company-information-management"
    | "contract-information-viewing"
  )[];
}

export interface UpdateCustomerUserRolesDto {
  roleIds: number[];
}

export interface ExtranetInviteTokenDto {
  id: number;
  customerId: number;
  token: string;
  userEmail: string;
  validTo: string;
  active: boolean;
  singleUse: boolean;
  user: ExtranetUserDto;
  roles: ExtranetCustomerUserRoleDto[];
}

export interface RegisterUserDto {
  firstName: string;
  lastName: string;
  email: string;
  username: string;
  password: string;
  phone?: string;
  streetName?: string;
  postCode?: string;
  townName?: string;
  countryName?: string;
  countryCode?: string;
  certificateCardNumber?: string;
  marketingAuthorization?: boolean;
  privacyPolicyApproval: boolean;
  termsOfUseApproval: boolean;
  cookiePolicyApproval?: boolean;
  professionalRolesSelected?: boolean;
  professionalRoleIds?: number[] | null;
}

export interface CheckInviteTokenDto {
  userEmail: string;
  customerId: number;
  roles: ExtranetCustomerUserRoleDto[];
}

export interface GetExtranetCustomerGroupQueryDto {
  groupName?: string;
}

export interface ExtranetCustomerGroupConsentDto {
  id: number;
  key: string;
  name: string;
}

export interface ExtranetCustomerGroupScheduleSlotDto {
  id: number;
  cycleDateIndex: number;
  deadlineTime: string;
  deadlineWeekday: string;
}

export interface ExtranetCustomerGroupDto {
  groupId: string;
  groupName: string;
  nextOrderTime: string;
  pricingProductId: number;
  productName: MultilingualKeyDto;
  active: boolean;
  dataReleaseConsents: ExtranetCustomerGroupConsentDto[];
  layoutId: number | null;
  omitStickers: boolean;
  pricingContractId: number;
  scheduleSlot: ExtranetCustomerGroupScheduleSlotDto | null;
}

export interface ExtranetUpdateCustomerGroupDto {
  pricingProductId: number;
  pricingContractId: number;
  scheduleSlotId: number;
  pouchLayoutId: number | null;
  dataReleaseConsentIds: number[];
  omitStickers: boolean;
}

export interface ExtranetCustomerGroupPouchLayoutDto {
  id: number;
  name: string;
}

export interface ExtranetCustomerGroupPricingContractDto {
  contractId: number;
  productName: string;
  pricingProductId: number;
}

export interface PostPricingReportByTypePdfDto {
  /** @format date */
  reportStartDate: string;
  /** @format date */
  reportEndDate: string;
  reportType: "purchaseReport" | "productBreakdown" | "customerGroupBreakdown";
}

export interface GetExtranetFaqCategoryQueryDto {
  categoryId?: number;
  name?: string;
  lang?: string;
}

export interface FaqContentDto {
  id: number;
  subject: MultilingualKeyDto;
  answer: MultilingualKeyDto;
  listIndex: number | null;
}

export interface ExtranetFaqCategoryDto {
  id: number;
  name: MultilingualKeyDto;
  contents: FaqContentDto[];
  listIndex: number | null;
}

export type FaqContentEntity = object;

export type EntityTimestamps = object;

export interface ContentImagesDto {
  desktop: string;
  desktopLarge: string;
  mobile: string;
}

export interface TagDto {
  id: number;
  name: MultilingualKeyDto;
}

export interface ExtranetNewsletterDto {
  id: number;
  title: MultilingualKeyDto;
  content: MultilingualKeyDto;
  image: ContentImagesDto;
  category: ExtranetNewsletterCategoryDto;
  tags: TagDto[];
  /** @format date-time */
  newsletterDate: string;
}

export interface ExtranetNewsletterCategoryDto {
  id: number;
  name: MultilingualKeyDto;
}

export interface GetExtranetNewslettersQueryDto {
  pageSize?: number;
  page?: number;
  sortKey?: string;
  sortOrder?: "asc" | "desc";
  lang?: string;
  categoryId?: number;
  categoryIds?: number[];
  search?: string;
}

export interface ExtranetServiceDescriptionRouteDto {
  path: MultilingualKeyDto;
  label: MultilingualKeyDto;
  menuLabel: MultilingualKeyDto;
  children: ExtranetServiceDescriptionRouteDto[];
  menuOrderIndex: number;
}

export interface ServiceDescriptionDto {
  id: number;
  image: ContentImagesDto;
  slug: MultilingualKeyDto;
  title: MultilingualKeyDto;
  content: MultilingualKeyDto;
  header: MultilingualKeyDto;
  banner: MultilingualKeyDto;
  experts: any[][];
}

export interface PharmacExpertDto {
  id: number;
  firstName: string;
  lastName: string;
  info: MultilingualKeyDto;
  additionalInfo: MultilingualKeyDto;
  image: ContentImagesDto;
  meetingLink: string;
  services: ServiceDescriptionDto[];
}

export interface ExtranetServiceDescriptionDto {
  id: number;
  image: ContentImagesDto;
  slug: MultilingualKeyDto;
  title: MultilingualKeyDto;
  content: MultilingualKeyDto;
  header: MultilingualKeyDto;
  banner: MultilingualKeyDto;
  experts: PharmacExpertDto[];
}

export enum ExtranetOrderStatusEnum {
  Arrived = "arrived",
  MissingInformation = "missing-information",
  InManufacturing = "in-manufacturing",
  Sent = "sent",
  Cancelled = "cancelled",
}

export interface GetExtranetOrderQueryDto {
  search?: string;
  pageSize?: number;
  page?: number;
  vnr?: string;
  hasChanges?: boolean;
  /** @format date */
  sendingDate?: string;
  /** @format date */
  startDate?: string;
  /** @format date */
  endDate?: string;
  /** @format date */
  startCreatedDateRange?: string;
  /** @format date */
  endCreatedDateRange?: string;
  /** @format date */
  startSendingDate?: string;
  /** @format date */
  endSendingDate?: string;
  status?: ExtranetOrderStatusEnum[];
}

export interface ExtranetOrderDto {
  id: number;
  rowId: string;
  wholeName: string;
  /** @format date */
  startDate: string;
  /** @format date */
  endDate: string;
  createdAt: string;
  /** @format date */
  sendingDate: string;
  anonymizedSocialSecurityNumber: string;
  /** @format date */
  deadlineDate: string | null;
  deadlineTime: string | null;
  isUrgent: boolean;
  status: ExtranetOrderStatusEnum;
  orderChangesFi: string[];
}

export interface ExtranetOrderListItemDto {
  groupId: string;
  groupName: string;
  /** @format date */
  createdAt: string;
  ordersCount: number;
  orders: ExtranetOrderDto[];
}

export interface GetExtranetProductShortageQueryDto {
  search?: string;
}

export interface ExtranetProductShortageOrderSubstituteProductDto {
  id: number;
  productNumber: string;
  nameFi: string | null;
  strength?: string | null;
}

export interface ExtranetProductShortageOrderProductDto {
  id: number;
  productNumber: string;
  nameFi: string | null;
  strength?: string | null;
  availableForCustomers: "Available" | "In short supply" | "To be discontinued" | "Discontinued" | "Out of stock";
  /** @format date */
  availableForCustomersFrom: string | null;
  substituteProduct: ExtranetProductShortageOrderSubstituteProductDto | null;
}

export interface ExtranetProductShortageOrderDto {
  id: number;
  anonymizedSocialSecurityNumber: string;
  wholeName: string;
  /** @format date */
  startDate: string;
  /** @format date */
  endDate: string;
  products: ExtranetProductShortageOrderProductDto[];
}

export interface ExtranetProductShortageListItemDto {
  groupId: string;
  groupName: string;
  ordersCount: number;
  orders: ExtranetProductShortageOrderDto[];
}

export interface ExtranetOrderChangesListDtoOrder {
  id: number;
  /** @format date */
  startDate: string;
  /** @format date */
  endDate: string;
  /** @format date */
  dateOfBirth: string;
  orderChanges: string[];
  wholeName: string;
}

export interface ExtranetOrderChangesListDtoGroup {
  groupId: string;
  groupName: string;
  orders: ExtranetOrderChangesListDtoOrder[];
}

export interface ExtranetOrderChangesListDto {
  groups: ExtranetOrderChangesListDtoGroup[];
}

export interface GetExtranetOrderTicketByGroupQueryDto {
  pageSize?: number;
  page?: number;
  sortOrder?: "asc" | "desc";
  customerGroupId?: string;
  /** @format date */
  deadlineDate?: string;
  deadlineTime?: string;
  active?: boolean;
}

export interface ExtranetOrderTicketListItemDto {
  id: number;
  orderId: number;
  wholeName: string;
  birthDate: string;
  /** @format date */
  deadlineDate: string;
  deadlineTime: string;
  /** @format date */
  sentAt: string;
  /** @format date */
  startDate: string;
  /** @format date */
  endDate: string;
}

export interface ExtranetOrderTicketOrderDetailsDto {
  id: number;
  wholeName: string;
  /** @format date */
  deadlineDate: string;
  deadlineTime: string;
  /** @format date */
  startDate: string;
  /** @format date */
  endDate: string;
}

export enum ExtranetOrderTicketStatus {
  Created = "created",
  SentToCustomer = "sent-to-customer",
  ConfirmedByCustomer = "confirmed-by-customer",
  Expired = "expired",
}

export enum ExtranetCustomerAvailability {
  Available = "Available",
  InShortSupply = "In short supply",
  ToBeDiscontinued = "To be discontinued",
  Discontinued = "Discontinued",
  OutOfStock = "Out of stock",
}

export interface OrderTicketOutOfStockProductDto {
  outOfStockProductNumber: string;
  outOfStockProductName: MultilingualKeyDto;
  outOfStockProductAvailability: ExtranetCustomerAvailability;
  substituteProductNumber: string;
  substituteProductName: MultilingualKeyDto;
  substituteProductStrength: string | null;
  comment: string;
  strength: string;
}

export interface ExtranetOrderTicketDetailsDto {
  id: number;
  order: ExtranetOrderTicketOrderDetailsDto;
  status: ExtranetOrderTicketStatus;
  /** @format date */
  sentAt: string;
  /** @format date */
  confirmedByCustomerAt: string;
  customerSignature: string;
  outOfStockProducts: OrderTicketOutOfStockProductDto[];
  isExpired: boolean;
  expiredAt: string | null;
}

export interface GetExtranetOrderTicketGroupQueryDto {
  pageSize?: number;
  page?: number;
  sortOrder?: "asc" | "desc";
  /** @format date */
  startDeadlineRange?: string;
  /** @format date */
  endDeadlineRange?: string;
  wholeName?: string;
}

export interface ExtranetOrderTicketGroupDto {
  /** @format date */
  deadlineDate: string;
  deadlineTime: string;
  customerGroupName: string;
  customerGroupId: string;
  /** @format date */
  latestTicketSentAt: string;
  ticketCount: number;
}

export interface GetExtranetOrderScheduleQueryDto {
  /** @format date */
  startDate: string;
  /** @format date */
  endDate: string;
}

export interface ExtranetOrderScheduleExceptionDeadlineDto {
  id: number;
  /** @format date */
  originalDeadlineDate: string;
  /** @format date */
  exceptionDeadlineDate: string;
  exceptionDeadlineTime: string;
  isSkipped: boolean;
}

export interface ExtranetOrderScheduleCustomerGroupDto {
  groupId: string;
  groupName: string;
  /** @format date */
  deadlineDate: string;
  deadlineTime: string;
  orderCountEstimate: number;
  cycleLength: number;
  estimatedDeliveredDate: string[];
  isSkipped: boolean;
  isDouble: boolean;
  exceptionEstimate: number;
  exceptions: ExtranetOrderScheduleExceptionDeadlineDto[];
}

export interface ExtranetOrderScheduleDeadlineDto {
  /** @format date */
  deadlineDate: string;
  deadlineTime: string;
  customerGroupCount: number;
  hasExceptions: boolean;
  customerGroups: ExtranetOrderScheduleCustomerGroupDto[];
}

export interface GetExtranetHeartbeatResponseDto {
  timestamp: number;
  message: string;
}

export interface GetExtranetSystemVersionResponseDto {
  timestamp: number;
  message: string;
}

export interface NameValuePairDto {
  name: string;
  type: "string" | "base64";
  value: string | null;
}

export interface OrderContentDrugImageDto {
  url: string;
  description: string;
}

export interface OrderContentsDrugDto {
  id: number;
  basicInfo: NameValuePairDto[];
  images: OrderContentDrugImageDto[];
}

export interface OrderContentsDto {
  id: number;
  drugs: OrderContentsDrugDto[];
}

export interface ExtranetTicketSubjectAreaDto {
  id: string;
  name: MultilingualKeyDto;
}

export enum ExtranetTicketStatusEnum {
  Value01New = "01 - New",
  Value02Solving = "02 - Solving",
  Value03PendingWaitingForCustomer = "03 - Pending - waiting for customer",
  Value04PendingWaitingFor3rdParty = "04 - Pending - waiting for 3rd party",
  Value05Reassigned = "05 - Reassigned",
  Value06Resolved = "06 - Resolved",
  Value07Closed = "07 - Closed",
  Value08CancelledByCustomer = "08 - Cancelled by customer",
}

export enum ExtranetTicketStatusCodeEnum {
  IncidentStatusNew = "incident_status_new",
  IncidentStatusSolving = "incident_status_solving",
  IncidentStatusWaitingforcustomer = "incident_status_waitingforcustomer",
  IncidentStatusWaitingfor3Rdparty = "incident_status_waitingfor3rdparty",
  IncidentStatusReassigned = "incident_status_reassigned",
  IncidentStatusResolved = "incident_status_resolved",
  IncidentStatusClosed = "incident_status_closed",
  IncidentStatusCancelledbycustomer = "incident_status_cancelledbycustomer",
}

export interface ExtranetTicketListItemDto {
  id: string;
  incidentId: string;
  status: ExtranetTicketStatusEnum;
  statusCode: ExtranetTicketStatusCodeEnum;
  subject: string;
  /** @format date */
  created: string;
  /** @format date */
  updated: string;
  extranetUserId: string;
  extranetUserName: string;
  isConfidential: boolean;
  isPrivate: boolean;
}

export interface ExtranetTicketListDto {
  data: ExtranetTicketListItemDto[];
}

export interface ExtranetTicketDto {
  id: string;
  incidentId: string;
  name: string;
  status: ExtranetTicketStatusEnum;
  statusCode: ExtranetTicketStatusCodeEnum;
  subject: string;
  description: string;
  created: string;
  updated: string;
  resolvedAt: string | null;
  extranetCustomerKelaNumber: string;
  extranetCustomerId: string;
  extranetCustomershipId: string;
  extranetCustomerName: string;
  extranetCustomerOfficialName: string;
  extranetUserId: string;
  extranetUserName: string;
  subjectArea: string;
  isConfidential: boolean;
  isPrivate: boolean;
}

export type MemoryStoredFile = object;

export interface ExtranetCreateTicketPostDto {
  title: string;
  description: string;
  isConfidential: boolean;
  isPrivate: boolean;
  subjectArea: string;
  files?: MemoryStoredFile[];
}

export interface ExtranetTicketAttachmentDto {
  originalFilename: string;
  filename: string;
  downloadPath: string;
}

export interface ExtranetDownloadTicketAttachmentDto {
  mime: string;
  /** @format base64 */
  base64: string;
}

export interface ExtranetUploadTicketAttachmentsDto {
  files: MemoryStoredFile[];
}

export interface ExtranetTicketCommentDto {
  author: string;
  value: string;
  /** @format date */
  date: string;
}

export interface ExtranetCreateTicketCommentPostDto {
  comment: string;
}

export interface ExtranetPhysicalProductListItemDto {
  id: number;
  productId: number;
  name: MultilingualKeyDto;
  productDescription: MultilingualKeyDto;
  images: ExtranetProductImageDto[];
  unitSellingPrice: number | null;
  taxRatePercentage: number | null;
}

export enum ExtranetPhysicalProductOrderStatus {
  Arrived = "arrived",
  Sent = "sent",
  Cancelled = "cancelled",
}

export interface ExtranetOrderedPhysicalProductItemListItemDto {
  id: number;
  name: MultilingualKeyDto;
  quantity: number;
  unitSellingPrice: number;
  totalSellingPrice: number;
  orderStatus: ExtranetPhysicalProductOrderStatus;
  /** @format date */
  orderCreatedAt: string;
}

export enum OrderedPhysicalProductsQuerySortKeys {
  Name = "name",
  ProductNumber = "productNumber",
}

export interface ExtranetPostPhysicalProductOrderDto {
  productId: number;
  quantity: number;
}

export interface ExtranetProductOrderDto {
  id: number;
  status: string;
  customerId: number;
  /** @format date */
  createdAt: string;
}

export interface GetEfecteChatEmbedUrlDto {
  embedUrl: string;
}

export interface PostEfecteChatTokenBodyDto {
  token: string;
}

export interface ConsumeEfecteChatTokenDto {
  /** @example "example.user" */
  userName: string;
  /** @example "Example" */
  firstName: string;
  /** @example "User" */
  lastName: string;
  /** @example "26e5d56e-2041-4d1a-bfc5-ebde3dca3b78" */
  userId: string;
  /** @example 42132144 */
  customerId: number;
  /** @example "Example customer" */
  customerName: string;
  /**
   * @format email
   * @example "example.user@example.customer.fi"
   */
  emailAddress: string;
}

export interface GetExtranetBannerQueryDto {
  lang?: string;
  view?: string;
}

export interface ExtranetBannerDto {
  id: number;
  title: MultilingualKeyDto;
  image: MultilingualKeyDto;
  mobileImage: MultilingualKeyDto;
  url: MultilingualKeyDto;
  view: string;
}

export enum OrderedShopProductsQuerySortKeys {
  Title = "title",
  PublishDate = "publishDate",
  UnitSellingPrice = "unitSellingPrice",
}

export enum ExtranetShopProductFamily {
  DocumentProduct = "document-product",
  PhysicalProduct = "physical-product",
  RecordingProduct = "recording-product",
  ServiceProduct = "service-product",
}

export enum ExtranetFreeOrPaidProductQueryKeys {
  Free = "free",
  Paid = "paid",
}

export enum ExtranetLanguageOption {
  Fi = "fi",
  Sv = "sv",
  En = "en",
}

export interface GetExtranetShopProductsQueryDto {
  search?: string;
  pageSize?: number;
  page?: number;
  sortKey?: OrderedShopProductsQuerySortKeys;
  sortOrder?: "asc" | "desc";
  productFamily?: ExtranetShopProductFamily[];
  productGroupId?: number;
  /** @format date */
  publishDateRangeStart?: string;
  /** @format date */
  publishDateRangeEnd?: string;
  tagIds?: number[];
  freeOrPaidProduct?: ExtranetFreeOrPaidProductQueryKeys;
  language?: ExtranetLanguageOption;
  filterByLanguage?: ExtranetLanguageOption;
  onlySubscribed?: boolean;
}

export interface ExtranetShopProductTagDto {
  id: number;
  name: string;
}

export interface ExtranetShopProductLanguageDto {
  id: number;
  code: string;
  name: string;
}

export interface ExtranetShopProductListItemDto {
  productId: number;
  title: string;
  isSubscribed: boolean;
  /** @format date */
  publishDate: string | null;
  description: string;
  unitSellingPrice: number;
  productFamily: string;
  productGroupId: number | null;
  image: ExtranetProductImageDto;
  videoDuration: number | null;
  canBeFreeSubscribed: boolean;
  canBeActivationCodeSubscribed: boolean;
  canBePurchased: boolean;
  tags: ExtranetShopProductTagDto[];
  language: ExtranetShopProductLanguageDto | null;
}

export interface GetExtranetProductFamiliesAndGroupsQueryDto {
  language?: ExtranetLanguageOption;
  ownProducts?: boolean;
}

export interface ExtranetShopAvailableProductGroupDto {
  productGroupId: number;
  productGroupName: string;
}

export interface ExtranetShopProductAvailableFamilyAndGroupsDto {
  productFamily: string;
  productGroups: ExtranetShopAvailableProductGroupDto[];
}

export interface GetExtranetProductLanguageQueryDto {
  language?: ExtranetLanguageOption;
}

export interface ExtranetTaxRateDto {
  id: number;
  percentage: number;
  description: string;
  isActive: boolean;
}

export interface ExtranetProductProfessionalRoleDto {
  id: number;
  role: string;
  displayName: string;
}

export interface ExtranetShopProductDto {
  productId: number;
  title: string;
  content: string;
  /** @format date */
  publishDate: string | null;
  taxRate: ExtranetTaxRateDto | null;
  unitSellingPrice: number;
  productFamily: string;
  isSubscribed: boolean;
  canBeFreeSubscribed: boolean;
  canBeActivationCodeSubscribed: boolean;
  canBePurchased: boolean;
  videoDuration: number | null;
  videoTeaserDuration: number | null;
  videoTeaserUrl: string | null;
  videoChapters: ExtranetChapterDto[];
  /** @format date */
  subscriptionEndDate: string | null;
  language: ExtranetLanguageDto | null;
  accessPeriod: ExtranetAccessPeriodDto | null;
  manufacturer: ExtranetManufacturerDto | null;
  tags: string[];
  professionalRoles: ExtranetProductProfessionalRoleDto[];
  images: ExtranetProductImageDto[];
}

export interface ExtranetSubscribeDto {
  productId: number;
}

export interface ExtranetActivationCodeDto {
  activationCode: string;
}

export interface ExtranetLocalizableMessage {
  messageKey: string;
  messageParameters: object;
}

export interface ExtranetActivatableProductPreviewDto {
  id: number;
  isOwned: boolean;
  name: string;
  description: string;
  productFamily: string;
  videoDuration: number | null;
  image: ExtranetProductImageDto | null;
  accessPeriod: ExtranetAccessPeriodDto;
  /** @format date */
  subscriptionEndDate: string | null;
  localizableMessages: ExtranetLocalizableMessage[];
  language: ExtranetLanguageDto;
}

export interface ExtranetShopPurchaseItemDto {
  productId: number;
  quantity: number;
}

export interface ExtranetPurchaseDto {
  items: ExtranetShopPurchaseItemDto[];
}

export enum ExtranetShopOrderItemStatus {
  Arrived = "arrived",
  BeingProcessed = "being-processed",
  Sent = "sent",
  Delivered = "delivered",
  Cancelled = "cancelled",
}

export interface ExtranetShopActivationCodeUserDto {
  firstName: string | null;
  lastName: string | null;
}

export interface ExtranetShopActivationCodeDto {
  code: string;
  isUsed: boolean;
  unlimitedAccess: boolean | null;
  subscriptionStartDate: string | null;
  subscriptionEndDate: string | null;
  usedBy: ExtranetShopActivationCodeUserDto | null;
}

export interface ExtranetOrderHistoryItemDto {
  orderRowNumber: number;
  productName: string;
  status: ExtranetShopOrderItemStatus;
  quantity: number;
  itemPrice: number;
  itemTotalPrice: number;
  deliveryId?: number | null;
  activationCodes: ExtranetShopActivationCodeDto[];
}

export enum ExtranetShopOrderStatusEnum {
  Arrived = "arrived",
  BeingProcessed = "being-processed",
  Completed = "completed",
  Cancelled = "cancelled",
}

export enum ErpExtranetShopOrderHistoryQuerySortKeys {
  OrderCreatedAt = "orderCreatedAt",
  Id = "id",
}

export interface GetExtranetShopOrderQueryDto {
  pageSize?: number;
  page?: number;
  status?: ExtranetShopOrderStatusEnum[];
  orderNumber?: string;
  buyer?: string;
  /** @format date */
  orderCreatedAt?: string;
  sortOrder?: "asc" | "desc";
  sortKey?: ErpExtranetShopOrderHistoryQuerySortKeys;
}

export interface ExtranetOrderHistoryListItemDto {
  orderNumber: number;
  orderCreatedAt: string;
  totalSellingPrice: number | null;
  orderStatus: ExtranetShopOrderStatusEnum;
  purchaser: string;
}

export interface ExtranetShopProductVideoDto {
  videoUrl: string;
}

import type { AxiosInstance, AxiosRequestConfig, HeadersDefaults, ResponseType } from "axios";
import axios from "axios";

export type QueryParamsType = Record<string | number, any>;

export interface FullRequestParams extends Omit<AxiosRequestConfig, "data" | "params" | "url" | "responseType"> {
  /** set parameter to `true` for call `securityWorker` for this request */
  secure?: boolean;
  /** request path */
  path: string;
  /** content type of request body */
  type?: ContentType;
  /** query params */
  query?: QueryParamsType;
  /** format of response (i.e. response.json() -> format: "json") */
  format?: ResponseType;
  /** request body */
  body?: unknown;
}

export type RequestParams = Omit<FullRequestParams, "body" | "method" | "query" | "path">;

export interface ApiConfig<SecurityDataType = unknown> extends Omit<AxiosRequestConfig, "data" | "cancelToken"> {
  securityWorker?: (
    securityData: SecurityDataType | null,
  ) => Promise<AxiosRequestConfig | void> | AxiosRequestConfig | void;
  secure?: boolean;
  format?: ResponseType;
}

export enum ContentType {
  Json = "application/json",
  FormData = "multipart/form-data",
  UrlEncoded = "application/x-www-form-urlencoded",
  Text = "text/plain",
}

export class HttpClient<SecurityDataType = unknown> {
  public instance: AxiosInstance;
  private securityData: SecurityDataType | null = null;
  private securityWorker?: ApiConfig<SecurityDataType>["securityWorker"];
  private secure?: boolean;
  private format?: ResponseType;

  constructor({ securityWorker, secure, format, ...axiosConfig }: ApiConfig<SecurityDataType> = {}) {
    this.instance = axios.create({ ...axiosConfig, baseURL: axiosConfig.baseURL || "" });
    this.secure = secure;
    this.format = format;
    this.securityWorker = securityWorker;
  }

  public setSecurityData = (data: SecurityDataType | null) => {
    this.securityData = data;
  };

  protected mergeRequestParams(params1: AxiosRequestConfig, params2?: AxiosRequestConfig): AxiosRequestConfig {
    const method = params1.method || (params2 && params2.method);

    return {
      ...this.instance.defaults,
      ...params1,
      ...(params2 || {}),
      headers: {
        ...((method && this.instance.defaults.headers[method.toLowerCase() as keyof HeadersDefaults]) || {}),
        ...(params1.headers || {}),
        ...((params2 && params2.headers) || {}),
      },
    };
  }

  protected stringifyFormItem(formItem: unknown) {
    if (typeof formItem === "object" && formItem !== null) {
      return JSON.stringify(formItem);
    } else {
      return `${formItem}`;
    }
  }

  protected createFormData(input: Record<string, unknown>): FormData {
    if (input instanceof FormData) {
      return input;
    }
    return Object.keys(input || {}).reduce((formData, key) => {
      const property = input[key];
      const propertyContent: any[] = property instanceof Array ? property : [property];

      for (const formItem of propertyContent) {
        const isFileType = formItem instanceof Blob || formItem instanceof File;
        formData.append(key, isFileType ? formItem : this.stringifyFormItem(formItem));
      }

      return formData;
    }, new FormData());
  }

  public request = async <T = any, _E = any>({
    secure,
    path,
    type,
    query,
    format,
    body,
    ...params
  }: FullRequestParams): Promise<T> => {
    const secureParams =
      ((typeof secure === "boolean" ? secure : this.secure) &&
        this.securityWorker &&
        (await this.securityWorker(this.securityData))) ||
      {};
    const requestParams = this.mergeRequestParams(params, secureParams);
    const responseFormat = format || this.format || undefined;

    if (type === ContentType.FormData && body && body !== null && typeof body === "object") {
      body = this.createFormData(body as Record<string, unknown>);
    }

    if (type === ContentType.Text && body && body !== null && typeof body !== "string") {
      body = JSON.stringify(body);
    }

    return this.instance
      .request({
        ...requestParams,
        headers: {
          ...(requestParams.headers || {}),
          ...(type ? { "Content-Type": type } : {}),
        },
        params: query,
        responseType: responseFormat,
        data: body,
        url: path,
      })
      .then((response) => response.data);
  };
}

/**
 * @title Extranet API
 * @version 1.0
 * @contact
 *
 * Extranet API
 */
export class Api<SecurityDataType extends unknown> extends HttpClient<SecurityDataType> {
  users = {
    /**
     * No description
     *
     * @name GetLoggedInUser
     * @request GET:/v1/users/me
     */
    getLoggedInUser: (params: RequestParams = {}) =>
      this.request<ExtranetUserDto, any>({
        path: `/v1/users/me`,
        method: "GET",
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @name UpdateUserInformation
     * @request PUT:/v1/users/me
     */
    updateUserInformation: (data: UpdateUserInformationBodyDto, params: RequestParams = {}) =>
      this.request<ExtranetUserDto, any>({
        path: `/v1/users/me`,
        method: "PUT",
        body: data,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @name GetLoggedInUserCustomers
     * @request GET:/v1/users/me/customers
     */
    getLoggedInUserCustomers: (params: RequestParams = {}) =>
      this.request<ExtranetCustomerListItemDto[], any>({
        path: `/v1/users/me/customers`,
        method: "GET",
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @name UpdateUserCookieApproval
     * @request PUT:/v1/users/me/approvals/cookie-policy
     */
    updateUserCookieApproval: (data: UpdateUserApprovalBodyDto, params: RequestParams = {}) =>
      this.request<ExtranetUserDto, any>({
        path: `/v1/users/me/approvals/cookie-policy`,
        method: "PUT",
        body: data,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @name UpdateUserMarketingApproval
     * @request PUT:/v1/users/me/approvals/marketing-policy
     */
    updateUserMarketingApproval: (data: UpdateUserApprovalBodyDto, params: RequestParams = {}) =>
      this.request<ExtranetUserDto, any>({
        path: `/v1/users/me/approvals/marketing-policy`,
        method: "PUT",
        body: data,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @name UpdateUserPrivacyApproval
     * @request PUT:/v1/users/me/approvals/privacy-policy
     */
    updateUserPrivacyApproval: (data: UpdateUserApprovalBodyDto, params: RequestParams = {}) =>
      this.request<ExtranetUserDto, any>({
        path: `/v1/users/me/approvals/privacy-policy`,
        method: "PUT",
        body: data,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @name UpdateUserTermsOfServiceApproval
     * @request PUT:/v1/users/me/approvals/terms-of-service
     */
    updateUserTermsOfServiceApproval: (data: UpdateUserApprovalBodyDto, params: RequestParams = {}) =>
      this.request<ExtranetUserDto, any>({
        path: `/v1/users/me/approvals/terms-of-service`,
        method: "PUT",
        body: data,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),
  };
  products = {
    /**
     * No description
     *
     * @name GetDoseDispensingProducts
     * @request GET:/v1/products
     */
    getDoseDispensingProducts: (
      query: {
        cid: number;
        pageSize?: number;
        page?: number;
        sortKey?: DoseDispensingProductSortKey;
        sortOrder?: "asc" | "desc";
        manufacturerName?: string;
        halving?: DoseDispensingProductHalving[];
        search?: string;
        availableForCustomers?: DoseDispensingProductAvailability[];
        type?: DoseDispensingProductType[];
      },
      params: RequestParams = {},
    ) =>
      this.request<
        ListDto & {
          data?: DoseDispensingProductsListItemDto[];
        },
        any
      >({
        path: `/v1/products`,
        method: "GET",
        query: query,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @name GetDoseDispensingProductMetadata
     * @request GET:/v1/products/{vnr}/metadata
     */
    getDoseDispensingProductMetadata: (vnr: string, params: RequestParams = {}) =>
      this.request<ExtranetDoseDispensingProductMetadataDto, any>({
        path: `/v1/products/${vnr}/metadata`,
        method: "GET",
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @name GetPhotobankData
     * @request GET:/v1/products/{vnr}/photobank-data
     */
    getPhotobankData: (vnr: string, params: RequestParams = {}) =>
      this.request<ExtranetPhotobankProductDto, any>({
        path: `/v1/products/${vnr}/photobank-data`,
        method: "GET",
        format: "json",
        ...params,
      }),
  };
  materialProducts = {
    /**
     * No description
     *
     * @name GetMaterialProducts
     * @request GET:/v1/material-products
     * @deprecated
     */
    getMaterialProducts: (
      query: {
        search?: string;
        pageSize?: number;
        customerId: number;
        page?: number;
        /** @format date */
        beforeDate?: string;
        /** @format date */
        afterDate?: string;
        tagIds?: number[];
        type?: ExtranetMaterialProductEnum;
        ids?: string[];
        language?: ExtranetMaterialLanguageOption;
      },
      params: RequestParams = {},
    ) =>
      this.request<
        ListDto & {
          data?: ExtranetMaterialProductListItemDto[];
        },
        any
      >({
        path: `/v1/material-products`,
        method: "GET",
        query: query,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @name GetMaterialProductTags
     * @request GET:/v1/material-products/tags
     * @deprecated
     */
    getMaterialProductTags: (
      query?: {
        lang?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<ExtranetTagDto[], any>({
        path: `/v1/material-products/tags`,
        method: "GET",
        query: query,
        format: "json",
        ...params,
      }),
  };
  customers = {
    /**
     * No description
     *
     * @name GetAvailableRoles
     * @request GET:/v1/customers/available-roles
     */
    getAvailableRoles: (params: RequestParams = {}) =>
      this.request<ExtranetCustomerUserRoleDto[], any>({
        path: `/v1/customers/available-roles`,
        method: "GET",
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @name GeUserProfessionalRoles
     * @request GET:/v1/customers/professional-roles
     */
    geUserProfessionalRoles: (params: RequestParams = {}) =>
      this.request<ExtranetCustomerUserProfessionalRoleDto[], any>({
        path: `/v1/customers/professional-roles`,
        method: "GET",
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @name GetPagedCustomers
     * @request GET:/v1/customers
     */
    getPagedCustomers: (
      query: {
        pageSize?: number;
        page?: number;
        sortKey?: string;
        sortOrder?: "asc" | "desc";
        name: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<
        ListDto & {
          data?: ExtranetCustomerListItemDto[];
        },
        any
      >({
        path: `/v1/customers`,
        method: "GET",
        query: query,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @name GetCustomerByCustomerId
     * @request GET:/v1/customers/{id}
     */
    getCustomerByCustomerId: (id: number, params: RequestParams = {}) =>
      this.request<ExtranetCustomerDetailsDto, any>({
        path: `/v1/customers/${id}`,
        method: "GET",
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @name GetCustomerUserRoles
     * @request GET:/v1/customers/{id}/roles/{uid}
     */
    getCustomerUserRoles: (id: number, uid: string, params: RequestParams = {}) =>
      this.request<ExtranetCustomerUserRolesDto, any>({
        path: `/v1/customers/${id}/roles/${uid}`,
        method: "GET",
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @name UpdateCustomerUserRoles
     * @request PUT:/v1/customers/{id}/roles/{uid}
     */
    updateCustomerUserRoles: (id: number, uid: string, data: UpdateCustomerUserRolesDto, params: RequestParams = {}) =>
      this.request<ExtranetCustomerUserRolesDto, any>({
        path: `/v1/customers/${id}/roles/${uid}`,
        method: "PUT",
        body: data,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @name GetCustomerUsers
     * @request GET:/v1/customers/{id}/users
     */
    getCustomerUsers: (id: number, params: RequestParams = {}) =>
      this.request<ExtranetUserDto[], any>({
        path: `/v1/customers/${id}/users`,
        method: "GET",
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @name GetMyCustomerUserRoles
     * @request GET:/v1/customers/{id}/me
     */
    getMyCustomerUserRoles: (id: number, params: RequestParams = {}) =>
      this.request<ExtranetCustomerUserRolesDto, any>({
        path: `/v1/customers/${id}/me`,
        method: "GET",
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @name PostInviteCustomerUser
     * @request POST:/v1/customers/{id}/users/invite
     */
    postInviteCustomerUser: (id: number, data: PostInviteUserBodyDto, params: RequestParams = {}) =>
      this.request<ExtranetInviteUserDto, any>({
        path: `/v1/customers/${id}/users/invite`,
        method: "POST",
        body: data,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @name RemoveCustomerUser
     * @request DELETE:/v1/customers/{id}/users/{uid}
     */
    removeCustomerUser: (id: number, uid: string, params: RequestParams = {}) =>
      this.request<ExtranetCustomerUserRolesDto, any>({
        path: `/v1/customers/${id}/users/${uid}`,
        method: "DELETE",
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @name GetCustomerInviteTokens
     * @request GET:/v1/customers/{id}/invite-tokens
     */
    getCustomerInviteTokens: (id: number, params: RequestParams = {}) =>
      this.request<ExtranetInviteTokenDto[], any>({
        path: `/v1/customers/${id}/invite-tokens`,
        method: "GET",
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @name DeleteInviteToken
     * @request DELETE:/v1/customers/{id}/invite-tokens/{tokenId}
     */
    deleteInviteToken: (id: number, tokenId: number, params: RequestParams = {}) =>
      this.request<void, any>({
        path: `/v1/customers/${id}/invite-tokens/${tokenId}`,
        method: "DELETE",
        ...params,
      }),

    /**
     * No description
     *
     * @name RegisterUserWithInviteToken
     * @request POST:/v1/customers/user-registration/{token}
     */
    registerUserWithInviteToken: (token: string, data: RegisterUserDto, params: RequestParams = {}) =>
      this.request<ExtranetUserDto, any>({
        path: `/v1/customers/user-registration/${token}`,
        method: "POST",
        body: data,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @name GetInviteTokenInfo
     * @request GET:/v1/customers/user-registration/{token}/info
     */
    getInviteTokenInfo: (token: string, params: RequestParams = {}) =>
      this.request<CheckInviteTokenDto, any>({
        path: `/v1/customers/user-registration/${token}/info`,
        method: "GET",
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @name ConsumeInviteToken
     * @request POST:/v1/customers/user-registration/{token}/consume
     */
    consumeInviteToken: (token: string, params: RequestParams = {}) =>
      this.request<ExtranetInviteTokenDto, any>({
        path: `/v1/customers/user-registration/${token}/consume`,
        method: "POST",
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @name GetCustomerGroups
     * @request GET:/v1/customers/{customerId}/customer-groups
     */
    getCustomerGroups: (
      customerId: number,
      query?: {
        groupName?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<ExtranetCustomerGroupDto[], any>({
        path: `/v1/customers/${customerId}/customer-groups`,
        method: "GET",
        query: query,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @name UpdateCustomerGroup
     * @request PUT:/v1/customers/{customerId}/customer-groups/{groupId}
     */
    updateCustomerGroup: (
      customerId: number,
      groupId: string,
      data: ExtranetUpdateCustomerGroupDto,
      params: RequestParams = {},
    ) =>
      this.request<ExtranetCustomerGroupDto[], any>({
        path: `/v1/customers/${customerId}/customer-groups/${groupId}`,
        method: "PUT",
        body: data,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @name GetCustomerGroupConsents
     * @request GET:/v1/customers/customer-groups/consents
     */
    getCustomerGroupConsents: (params: RequestParams = {}) =>
      this.request<ExtranetCustomerGroupConsentDto[], any>({
        path: `/v1/customers/customer-groups/consents`,
        method: "GET",
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @name GetCustomerGroupScheduleSlots
     * @request GET:/v1/customers/{customerId}/customer-groups/schedule-slots
     */
    getCustomerGroupScheduleSlots: (customerId: number, params: RequestParams = {}) =>
      this.request<ExtranetCustomerGroupScheduleSlotDto[], any>({
        path: `/v1/customers/${customerId}/customer-groups/schedule-slots`,
        method: "GET",
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @name GetCustomerGroupPouchLayout
     * @request GET:/v1/customers/{customerId}/customer-groups/pouch-layouts
     */
    getCustomerGroupPouchLayout: (customerId: number, params: RequestParams = {}) =>
      this.request<ExtranetCustomerGroupPouchLayoutDto[], any>({
        path: `/v1/customers/${customerId}/customer-groups/pouch-layouts`,
        method: "GET",
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @name GetCustomerGroupPricing
     * @request GET:/v1/customers/{customerId}/customer-groups/{groupId}/pricing-contracts
     */
    getCustomerGroupPricing: (customerId: number, groupId: string, params: RequestParams = {}) =>
      this.request<ExtranetCustomerGroupPricingContractDto[], any>({
        path: `/v1/customers/${customerId}/customer-groups/${groupId}/pricing-contracts`,
        method: "GET",
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @name ResetCustomerApiKey
     * @request PUT:/v1/customers/{customerId}/api-key
     */
    resetCustomerApiKey: (customerId: number, params: RequestParams = {}) =>
      this.request<string, any>({
        path: `/v1/customers/${customerId}/api-key`,
        method: "PUT",
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @name GetPricingReportByTypeAndDate
     * @request POST:/v1/customers/{customerId}/pricing-report-type-date
     */
    getPricingReportByTypeAndDate: (
      customerId: number,
      data: PostPricingReportByTypePdfDto,
      params: RequestParams = {},
    ) =>
      this.request<File, any>({
        path: `/v1/customers/${customerId}/pricing-report-type-date`,
        method: "POST",
        body: data,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),
  };
  faqs = {
    /**
     * No description
     *
     * @name GetCategories
     * @request GET:/v1/faqs/categories
     */
    getCategories: (
      query?: {
        categoryId?: number;
        name?: string;
        lang?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<ExtranetFaqCategoryDto[], any>({
        path: `/v1/faqs/categories`,
        method: "GET",
        query: query,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @name GetContents
     * @request GET:/v1/faqs/contents
     */
    getContents: (params: RequestParams = {}) =>
      this.request<FaqContentEntity[], any>({
        path: `/v1/faqs/contents`,
        method: "GET",
        format: "json",
        ...params,
      }),
  };
  newsletters = {
    /**
     * No description
     *
     * @name GetNewsletters
     * @request GET:/v1/newsletters
     */
    getNewsletters: (
      query?: {
        pageSize?: number;
        page?: number;
        sortKey?: string;
        sortOrder?: "asc" | "desc";
        lang?: string;
        categoryId?: number;
        categoryIds?: number[];
        search?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<
        ListDto & {
          data?: ExtranetNewsletterDto[];
        },
        any
      >({
        path: `/v1/newsletters`,
        method: "GET",
        query: query,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @name GetNewsletterById
     * @request GET:/v1/newsletters/{id}
     */
    getNewsletterById: (
      id: number,
      query?: {
        lang?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<ExtranetNewsletterDto, any>({
        path: `/v1/newsletters/${id}`,
        method: "GET",
        query: query,
        format: "json",
        ...params,
      }),
  };
  newsletterCategories = {
    /**
     * No description
     *
     * @name GetCategories
     * @request GET:/v1/newsletter-categories
     */
    getCategories: (
      query?: {
        lang?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<ExtranetNewsletterCategoryDto[], any>({
        path: `/v1/newsletter-categories`,
        method: "GET",
        query: query,
        format: "json",
        ...params,
      }),
  };
  tags = {
    /**
     * No description
     *
     * @name GetTags
     * @request GET:/v1/tags
     */
    getTags: (params: RequestParams = {}) =>
      this.request<TagDto[], any>({
        path: `/v1/tags`,
        method: "GET",
        format: "json",
        ...params,
      }),
  };
  services = {
    /**
     * No description
     *
     * @name GetServicesRoutes
     * @request GET:/v1/services/routes/{customerId}
     */
    getServicesRoutes: (customerId?: number, params: RequestParams = {}) =>
      this.request<ExtranetServiceDescriptionRouteDto[], any>({
        path: `/v1/services/routes/${customerId}`,
        method: "GET",
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @name GetServiceBySlug
     * @request GET:/v1/services/{customerId}/slugs/{slug}
     */
    getServiceBySlug: (slug: string, customerId: number, params: RequestParams = {}) =>
      this.request<ExtranetServiceDescriptionDto, any>({
        path: `/v1/services/${customerId}/slugs/${slug}`,
        method: "GET",
        format: "json",
        ...params,
      }),
  };
  orders = {
    /**
     * No description
     *
     * @name GetOrderHistory
     * @request GET:/v1/orders/{customerId}
     */
    getOrderHistory: (
      customerId: number,
      query?: {
        search?: string;
        pageSize?: number;
        page?: number;
        vnr?: string;
        hasChanges?: boolean;
        /** @format date */
        sendingDate?: string;
        /** @format date */
        startDate?: string;
        /** @format date */
        endDate?: string;
        /** @format date */
        startCreatedDateRange?: string;
        /** @format date */
        endCreatedDateRange?: string;
        /** @format date */
        startSendingDate?: string;
        /** @format date */
        endSendingDate?: string;
        status?: ExtranetOrderStatusEnum[];
      },
      params: RequestParams = {},
    ) =>
      this.request<
        ListDto & {
          data?: ExtranetOrderListItemDto[];
        },
        any
      >({
        path: `/v1/orders/${customerId}`,
        method: "GET",
        query: query,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @name GetProductShortages
     * @request GET:/v1/orders/{customerId}/product-shortages
     */
    getProductShortages: (
      customerId: number,
      query?: {
        search?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<ExtranetProductShortageListItemDto[], any>({
        path: `/v1/orders/${customerId}/product-shortages`,
        method: "GET",
        query: query,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @name GetOrderChangesList
     * @request GET:/v1/orders/{customerId}/order-changes
     */
    getOrderChangesList: (
      customerId: number,
      query: {
        orderIds: number[];
      },
      params: RequestParams = {},
    ) =>
      this.request<ExtranetOrderChangesListDto, any>({
        path: `/v1/orders/${customerId}/order-changes`,
        method: "GET",
        query: query,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @name GetDosingCardForOrderId
     * @request GET:/v1/orders/{customerId}/dosing-cards/{orderId}
     */
    getDosingCardForOrderId: (customerId: number, orderId: number, params: RequestParams = {}) =>
      this.request<any, any>({
        path: `/v1/orders/${customerId}/dosing-cards/${orderId}`,
        method: "GET",
        ...params,
      }),

    /**
     * No description
     *
     * @name GetDosingCardsForOrderIds
     * @request GET:/v1/orders/{customerId}/dosing-cards
     */
    getDosingCardsForOrderIds: (
      customerId: number,
      query: {
        ids: number[];
      },
      params: RequestParams = {},
    ) =>
      this.request<any, any>({
        path: `/v1/orders/${customerId}/dosing-cards`,
        method: "GET",
        query: query,
        ...params,
      }),

    /**
     * No description
     *
     * @name ConfirmOrderTicket
     * @request POST:/v1/orders/{customerId}/tickets/{ticketId}/confirm
     */
    confirmOrderTicket: (customerId: number, ticketId: number, params: RequestParams = {}) =>
      this.request<string, any>({
        path: `/v1/orders/${customerId}/tickets/${ticketId}/confirm`,
        method: "POST",
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @name GetOrderTicketsByGroup
     * @request GET:/v1/orders/{customerId}/tickets
     */
    getOrderTicketsByGroup: (
      customerId: number,
      query?: {
        pageSize?: number;
        page?: number;
        sortOrder?: "asc" | "desc";
        customerGroupId?: string;
        /** @format date */
        deadlineDate?: string;
        deadlineTime?: string;
        active?: boolean;
      },
      params: RequestParams = {},
    ) =>
      this.request<ExtranetOrderTicketListItemDto[], any>({
        path: `/v1/orders/${customerId}/tickets`,
        method: "GET",
        query: query,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @name GetOrderTicketById
     * @request GET:/v1/orders/{customerId}/tickets/{ticketId}
     */
    getOrderTicketById: (ticketId: number, customerId: number, params: RequestParams = {}) =>
      this.request<ExtranetOrderTicketDetailsDto, any>({
        path: `/v1/orders/${customerId}/tickets/${ticketId}`,
        method: "GET",
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @name GetCompletedOrderTicketGroups
     * @request GET:/v1/orders/{customerId}/tickets/groups/completed
     */
    getCompletedOrderTicketGroups: (
      customerId: number,
      query?: {
        pageSize?: number;
        page?: number;
        sortOrder?: "asc" | "desc";
        /** @format date */
        startDeadlineRange?: string;
        /** @format date */
        endDeadlineRange?: string;
        wholeName?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<
        ListDto & {
          data?: ExtranetOrderTicketGroupDto[];
        },
        any
      >({
        path: `/v1/orders/${customerId}/tickets/groups/completed`,
        method: "GET",
        query: query,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @name GetAllActiveOrderTicketGroups
     * @request GET:/v1/orders/{customerId}/tickets/groups/active
     */
    getAllActiveOrderTicketGroups: (customerId: number, params: RequestParams = {}) =>
      this.request<ExtranetOrderTicketGroupDto[], any>({
        path: `/v1/orders/${customerId}/tickets/groups/active`,
        method: "GET",
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @name GetOrderScheduleDeadlines
     * @request GET:/v1/orders/{customerId}/schedules
     */
    getOrderScheduleDeadlines: (
      customerId: number,
      query: {
        /** @format date */
        startDate: string;
        /** @format date */
        endDate: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<ExtranetOrderScheduleDeadlineDto[], any>({
        path: `/v1/orders/${customerId}/schedules`,
        method: "GET",
        query: query,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @name GetExceptionDeadlines
     * @request GET:/v1/orders/{customerId}/exception-deadlines
     */
    getExceptionDeadlines: (
      customerId: number,
      query: {
        /** @format date */
        startDate: string;
        /** @format date */
        endDate: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<ExtranetOrderScheduleDeadlineDto[], any>({
        path: `/v1/orders/${customerId}/exception-deadlines`,
        method: "GET",
        query: query,
        format: "json",
        ...params,
      }),
  };
  heartbeat = {
    /**
     * No description
     *
     * @name GetHeartbeat
     * @request GET:/v1/heartbeat
     */
    getHeartbeat: (params: RequestParams = {}) =>
      this.request<GetExtranetHeartbeatResponseDto, any>({
        path: `/v1/heartbeat`,
        method: "GET",
        format: "json",
        ...params,
      }),
  };
  systemVersion = {
    /**
     * No description
     *
     * @name GetSystemVersion
     * @request GET:/v1/system-version
     */
    getSystemVersion: (params: RequestParams = {}) =>
      this.request<GetExtranetSystemVersionResponseDto, any>({
        path: `/v1/system-version`,
        method: "GET",
        format: "json",
        ...params,
      }),
  };
  orderContents = {
    /**
     * No description
     *
     * @name GetOrderContentsData
     * @request GET:/v1/order-contents
     */
    getOrderContentsData: (
      query?: {
        rowId?: string;
        pouchId?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<OrderContentsDto, any>({
        path: `/v1/order-contents`,
        method: "GET",
        query: query,
        format: "json",
        ...params,
      }),
  };
  tickets = {
    /**
     * No description
     *
     * @tags Tickets
     * @name GetSubjectAreas
     * @request GET:/v1/tickets/{customerId}/subject-areas
     */
    getSubjectAreas: (customerId: number, params: RequestParams = {}) =>
      this.request<ExtranetTicketSubjectAreaDto[], any>({
        path: `/v1/tickets/${customerId}/subject-areas`,
        method: "GET",
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Tickets
     * @name GetOpenTickets
     * @request GET:/v1/tickets/{customerId}/open
     */
    getOpenTickets: (customerId: number, params: RequestParams = {}) =>
      this.request<ExtranetTicketListDto, any>({
        path: `/v1/tickets/${customerId}/open`,
        method: "GET",
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Tickets
     * @name GetClosedTickets
     * @request GET:/v1/tickets/{customerId}/closed
     */
    getClosedTickets: (customerId: number, params: RequestParams = {}) =>
      this.request<ExtranetTicketListDto, any>({
        path: `/v1/tickets/${customerId}/closed`,
        method: "GET",
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Tickets
     * @name GetSingleTicket
     * @request GET:/v1/tickets/{customerId}/{id}
     */
    getSingleTicket: (customerId: number, id: string, params: RequestParams = {}) =>
      this.request<ExtranetTicketDto, any>({
        path: `/v1/tickets/${customerId}/${id}`,
        method: "GET",
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Tickets
     * @name CreateTicket
     * @request POST:/v1/tickets/{customerId}
     */
    createTicket: (customerId: number, data: ExtranetCreateTicketPostDto, params: RequestParams = {}) =>
      this.request<ExtranetTicketDto, any>({
        path: `/v1/tickets/${customerId}`,
        method: "POST",
        body: data,
        type: ContentType.FormData,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Tickets
     * @name GetTicketAttachments
     * @request GET:/v1/tickets/{customerId}/{ticketId}/attachments
     */
    getTicketAttachments: (customerId: number, ticketId: string, params: RequestParams = {}) =>
      this.request<ExtranetTicketAttachmentDto[], any>({
        path: `/v1/tickets/${customerId}/${ticketId}/attachments`,
        method: "GET",
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Tickets
     * @name PostTicketAttachment
     * @request POST:/v1/tickets/{customerId}/{ticketId}/attachments
     */
    postTicketAttachment: (
      customerId: number,
      ticketId: string,
      data: ExtranetUploadTicketAttachmentsDto,
      params: RequestParams = {},
    ) =>
      this.request<ExtranetTicketAttachmentDto[], any>({
        path: `/v1/tickets/${customerId}/${ticketId}/attachments`,
        method: "POST",
        body: data,
        type: ContentType.FormData,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Tickets
     * @name DownloadAttachmentFile
     * @request GET:/v1/tickets/{customerId}/{ticketId}/attachments/{fileLocation}
     */
    downloadAttachmentFile: (customerId: number, ticketId: string, fileLocation: string, params: RequestParams = {}) =>
      this.request<ExtranetDownloadTicketAttachmentDto, any>({
        path: `/v1/tickets/${customerId}/${ticketId}/attachments/${fileLocation}`,
        method: "GET",
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Tickets
     * @name GetTicketComments
     * @request GET:/v1/tickets/{customerId}/{ticketId}/comments
     */
    getTicketComments: (customerId: number, ticketId: string, params: RequestParams = {}) =>
      this.request<ExtranetTicketCommentDto[], any>({
        path: `/v1/tickets/${customerId}/${ticketId}/comments`,
        method: "GET",
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Tickets
     * @name SendComment
     * @request POST:/v1/tickets/{customerId}/{ticketId}/comments
     */
    sendComment: (
      customerId: number,
      ticketId: string,
      data: ExtranetCreateTicketCommentPostDto,
      params: RequestParams = {},
    ) =>
      this.request<ExtranetTicketCommentDto[], any>({
        path: `/v1/tickets/${customerId}/${ticketId}/comments`,
        method: "POST",
        body: data,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Tickets
     * @name CloseTicket
     * @request POST:/v1/tickets/{customerId}/{ticketId}/close
     */
    closeTicket: (customerId: number, ticketId: string, params: RequestParams = {}) =>
      this.request<ExtranetTicketDto, any>({
        path: `/v1/tickets/${customerId}/${ticketId}/close`,
        method: "POST",
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Tickets
     * @name CancelTicket
     * @request POST:/v1/tickets/{customerId}/{ticketId}/cancel
     */
    cancelTicket: (customerId: number, ticketId: string, params: RequestParams = {}) =>
      this.request<ExtranetTicketDto, any>({
        path: `/v1/tickets/${customerId}/${ticketId}/cancel`,
        method: "POST",
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Tickets
     * @name ReopenTicket
     * @request POST:/v1/tickets/{customerId}/{ticketId}/open
     */
    reopenTicket: (customerId: number, ticketId: string, params: RequestParams = {}) =>
      this.request<ExtranetTicketDto, any>({
        path: `/v1/tickets/${customerId}/${ticketId}/open`,
        method: "POST",
        format: "json",
        ...params,
      }),
  };
  physicalProducts = {
    /**
     * No description
     *
     * @name GetPhysicalProducts
     * @request GET:/v1/physical-products/{customerId}
     */
    getPhysicalProducts: (
      customerId: number,
      query?: {
        lang?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<ExtranetPhysicalProductListItemDto[], any>({
        path: `/v1/physical-products/${customerId}`,
        method: "GET",
        query: query,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @name GetOrderedPhysicalProducts
     * @request GET:/v1/physical-products/{customerId}/orders/{productFamily}
     */
    getOrderedPhysicalProducts: (
      customerId: number,
      productFamily: string,
      query?: {
        pageSize?: number;
        page?: number;
        sortKey?: OrderedPhysicalProductsQuerySortKeys;
        sortOrder?: "asc" | "desc";
      },
      params: RequestParams = {},
    ) =>
      this.request<
        ListDto & {
          data?: ExtranetOrderedPhysicalProductItemListItemDto[];
        },
        any
      >({
        path: `/v1/physical-products/${customerId}/orders/${productFamily}`,
        method: "GET",
        query: query,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @name PostPhysicalProductOrder
     * @request POST:/v1/physical-products/{customerId}/orders
     */
    postPhysicalProductOrder: (
      customerId: number,
      data: ExtranetPostPhysicalProductOrderDto[],
      params: RequestParams = {},
    ) =>
      this.request<ExtranetProductOrderDto, any>({
        path: `/v1/physical-products/${customerId}/orders`,
        method: "POST",
        body: data,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),
  };
  chat = {
    /**
     * No description
     *
     * @name GetChatToken
     * @request GET:/v1/chat/token/{customerId}
     */
    getChatToken: (customerId: number, params: RequestParams = {}) =>
      this.request<string, any>({
        path: `/v1/chat/token/${customerId}`,
        method: "GET",
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @name GetChatEmbedUrl
     * @request GET:/v1/chat/embed-url
     */
    getChatEmbedUrl: (params: RequestParams = {}) =>
      this.request<GetEfecteChatEmbedUrlDto, any>({
        path: `/v1/chat/embed-url`,
        method: "GET",
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @name VerifyChatToken
     * @request POST:/v1/chat/token
     */
    verifyChatToken: (data: PostEfecteChatTokenBodyDto, params: RequestParams = {}) =>
      this.request<ConsumeEfecteChatTokenDto, any>({
        path: `/v1/chat/token`,
        method: "POST",
        body: data,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),
  };
  banners = {
    /**
     * No description
     *
     * @name GetAllBanners
     * @request GET:/v1/banners
     */
    getAllBanners: (
      query?: {
        lang?: string;
        view?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<ExtranetBannerDto[], any>({
        path: `/v1/banners`,
        method: "GET",
        query: query,
        format: "json",
        ...params,
      }),
  };
  shop = {
    /**
     * No description
     *
     * @name GetShopProducts
     * @request GET:/v1/shop/{customerId}/products
     */
    getShopProducts: (
      customerId: number,
      query?: {
        search?: string;
        pageSize?: number;
        page?: number;
        sortKey?: OrderedShopProductsQuerySortKeys;
        sortOrder?: "asc" | "desc";
        productFamily?: ExtranetShopProductFamily[];
        productGroupId?: number;
        /** @format date */
        publishDateRangeStart?: string;
        /** @format date */
        publishDateRangeEnd?: string;
        tagIds?: number[];
        freeOrPaidProduct?: ExtranetFreeOrPaidProductQueryKeys;
        language?: ExtranetLanguageOption;
        filterByLanguage?: ExtranetLanguageOption;
        onlySubscribed?: boolean;
      },
      params: RequestParams = {},
    ) =>
      this.request<
        ListDto & {
          data?: ExtranetShopProductListItemDto[];
        },
        any
      >({
        path: `/v1/shop/${customerId}/products`,
        method: "GET",
        query: query,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @name GetAvailableShopFamilies
     * @request GET:/v1/shop/{customerId}/products/available-families
     */
    getAvailableShopFamilies: (
      customerId: number,
      query?: {
        language?: ExtranetLanguageOption;
        ownProducts?: boolean;
      },
      params: RequestParams = {},
    ) =>
      this.request<ExtranetShopProductAvailableFamilyAndGroupsDto[], any>({
        path: `/v1/shop/${customerId}/products/available-families`,
        method: "GET",
        query: query,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @name GetShopProductById
     * @request GET:/v1/shop/{customerId}/products/{id}
     */
    getShopProductById: (
      customerId: number,
      id: number,
      query?: {
        language?: ExtranetLanguageOption;
      },
      params: RequestParams = {},
    ) =>
      this.request<ExtranetShopProductDto, any>({
        path: `/v1/shop/${customerId}/products/${id}`,
        method: "GET",
        query: query,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @name SubscribeToFreeProduct
     * @request POST:/v1/shop/{customerId}/products/subscribe-to-free-product
     */
    subscribeToFreeProduct: (customerId: number, data: ExtranetSubscribeDto, params: RequestParams = {}) =>
      this.request<void, any>({
        path: `/v1/shop/${customerId}/products/subscribe-to-free-product`,
        method: "POST",
        body: data,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @name SubscribeWithActivationCode
     * @request POST:/v1/shop/{customerId}/products/subscribe-with-activation-code
     */
    subscribeWithActivationCode: (customerId: number, data: ExtranetActivationCodeDto, params: RequestParams = {}) =>
      this.request<void, any>({
        path: `/v1/shop/${customerId}/products/subscribe-with-activation-code`,
        method: "POST",
        body: data,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @name DeleteFreeProductSubscription
     * @request DELETE:/v1/shop/{customerId}/products/{productId}/delete-free-product-subscription
     */
    deleteFreeProductSubscription: (customerId: number, productId: number, params: RequestParams = {}) =>
      this.request<void, any>({
        path: `/v1/shop/${customerId}/products/${productId}/delete-free-product-subscription`,
        method: "DELETE",
        ...params,
      }),

    /**
     * No description
     *
     * @name PreviewActivationCodeProduct
     * @request GET:/v1/shop/{customerId}/shop/activation-code-preview/{activationCode}
     */
    previewActivationCodeProduct: (
      customerId: number,
      activationCode: string,
      query?: {
        language?: ExtranetLanguageOption;
      },
      params: RequestParams = {},
    ) =>
      this.request<ExtranetActivatableProductPreviewDto, any>({
        path: `/v1/shop/${customerId}/shop/activation-code-preview/${activationCode}`,
        method: "GET",
        query: query,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @name PurchaseProduct
     * @request POST:/v1/shop/{customerId}/products/purchase
     */
    purchaseProduct: (customerId: number, data: ExtranetPurchaseDto, params: RequestParams = {}) =>
      this.request<void, any>({
        path: `/v1/shop/${customerId}/products/purchase`,
        method: "POST",
        body: data,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @name GetProductDocument
     * @request GET:/v1/shop/{customerId}/products/{id}/document
     */
    getProductDocument: (customerId: number, id: number, params: RequestParams = {}) =>
      this.request<File, any>({
        path: `/v1/shop/${customerId}/products/${id}/document`,
        method: "GET",
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @name FindProductOrderHistoryItems
     * @request GET:/v1/shop/{customerId}/order/{id}
     */
    findProductOrderHistoryItems: (
      customerId: number,
      id: number,
      query?: {
        language?: ExtranetLanguageOption;
      },
      params: RequestParams = {},
    ) =>
      this.request<ExtranetOrderHistoryItemDto[], any>({
        path: `/v1/shop/${customerId}/order/${id}`,
        method: "GET",
        query: query,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @name GetShopOrderHistory
     * @request GET:/v1/shop/{customerId}/orders
     */
    getShopOrderHistory: (
      customerId: number,
      query?: {
        pageSize?: number;
        page?: number;
        status?: ExtranetShopOrderStatusEnum[];
        orderNumber?: string;
        buyer?: string;
        /** @format date */
        orderCreatedAt?: string;
        sortOrder?: "asc" | "desc";
        sortKey?: ErpExtranetShopOrderHistoryQuerySortKeys;
      },
      params: RequestParams = {},
    ) =>
      this.request<
        ListDto & {
          data?: ExtranetOrderHistoryListItemDto[];
        },
        any
      >({
        path: `/v1/shop/${customerId}/orders`,
        method: "GET",
        query: query,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @name GetProductVideo
     * @request GET:/v1/shop/{customerId}/products/{id}/video
     */
    getProductVideo: (customerId: number, id: number, params: RequestParams = {}) =>
      this.request<ExtranetShopProductVideoDto, any>({
        path: `/v1/shop/${customerId}/products/${id}/video`,
        method: "GET",
        format: "json",
        ...params,
      }),
  };
}
